import type { StyleRule } from '@archipro-design/aria';
import {
    carouselOverlayClassName,
    carouselPaddlesContainerClassName,
    carouselPaddleClassName,
    carouselIndicatorClassName,
    pxToRem,
    pxArrayToRem,
} from '@archipro-design/aria';

export const PhotoViewerContainer: StyleRule = ({ theme }) => ({
    padding: 0,
    maxWidth: '100vw !important',
    maxHeight: '100vh',
    borderRadius: '0 !important',
    '& button': {
        background: 'transparent',
    },
    '& .ui-dialog__content': {
        borderRadius: 0,
        border: 'none',
        margin: 0,
        padding: 0,
        maxHeight: `100vh`,
        maxWidth: '100%',
        background: theme.siteVariables.colors.white['100A'],
        [`& .${carouselOverlayClassName}`]: {
            padding: 0,
            opacity: 1,
            '& > :last-child': {
                position: 'relative',
                bottom: pxToRem(25),
                left: pxToRem(31),
            },
        },

        [`& .${carouselIndicatorClassName}`]: {
            marginRight: pxToRem(11),
        },

        [`& .${carouselPaddlesContainerClassName}`]: {
            '& > :first-child': {
                left: pxToRem(28),
            },
            '& > :last-child': {
                right: pxToRem(28),
            },
        },

        [`& .${carouselPaddleClassName}`]: {
            background: theme.siteVariables.colors.primitive.white,
            [`& .${carouselPaddleClassName}__content`]: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '& span': {
                    height: pxToRem(26),
                    width: pxToRem(26),
                },
            },
        },
    },
    '& .ui-dialog__headerAction': {
        position: 'fixed',
        top: pxToRem(23),
        right: pxToRem(30),
        zIndex: 30,
        outline: 'none',
        border: 0,
        padding: 0,
    },
    '& .ui-dialog__footer': {
        display: 'none',
    },
});

export const StackContainer: StyleRule = () => ({
    padding: pxArrayToRem([231, 0]),
    gridGap: pxToRem(197),
});
